import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton, Icons, Text, Wrapper } from 'widget/components';
import { useChatBodyContext } from '../../chat-body-context';
import { useIsPrimaryDark } from 'widget/hooks';
import { useWidgetContext } from 'widget/widget-context';

const QuotedMsg = () => {
  const { widget } = useWidgetContext();
  const { quotedMessage, setQuotedMessage } = useChatBodyContext();

  const { t } = useTranslation();
  const isPrimaryDark = useIsPrimaryDark();

  const fill =
    widget.theme == 'dark'
      ? isPrimaryDark
        ? 'white'
        : undefined
      : !isPrimaryDark
        ? 'dark'
        : undefined;

  return (
    <Wrapper alignItems="center" gap={8} justifyContent="space-between">
      <Wrapper alignItems="center" gap={8} style={{ minWidth: 0 }}>
        <Icons.ArrowBendUpLeft fill={fill} size={20} />
        <div className="whatcrm-widget-chat__divider" />

        <div style={{ minWidth: 0 }}>
          <Text fontSize={12} fontWeight={600}>{t`Reply`}</Text>

          <Text fontSize={12} isEllipsis>
            {quotedMessage?.preview}
          </Text>
        </div>
      </Wrapper>

      <IconButton onClick={() => setQuotedMessage(undefined)}>
        <Icons.CircleClose fill="gray" size={24} />
      </IconButton>
    </Wrapper>
  );
};

export default QuotedMsg;
